export default __webpack_public_path__ + "static/media/StkTransferOn.f4c9209e.svg";